export default "__VITE_ASSET__NW3ewlB3__"